/**
 * Get the threat type portion of a detection string
 * @param detectionString string in format platform-subplatform.type.familyname
 */
export const getThreatType = (detectionString) => {
    const parts = detectionString.split(".");
    return parts.length === 3 ? parts[1] : null;
};
//# sourceMappingURL=threats.js.map